import { render, staticRenderFns } from "./Appheader.vue?vue&type=template&id=1d35f844"
import script from "./Appheader.vue?vue&type=script&lang=js"
export * from "./Appheader.vue?vue&type=script&lang=js"
import style0 from "./Appheader.vue?vue&type=style&index=0&id=1d35f844&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports